export default function tariffs() {

    $(document).on('click', '.tariffs_type-item__js', function (e) {
        $(".tariffs_type-item__js.active").removeClass('active');
        $(this).addClass('active');
    });

    const tariffInfoBlock  = $('.tariffs_info-anim__js');
    const tariffTitle      = $('.tariffs_info-title__js');
    const secondPriceBox   = $('.tariffs_info-price-item__js');
    const tariffPriceFirst = $('.tariffs_info-price-box-first__js');
    const tariffRequests   = $('.tariffs_info-price-box-second__js');
    const tariffHintRequests   = $('.tariffs_info-price-hint-box-second__js');
    const tariffText       = $('.tariffs_info-text__js');

    // если нужно будет менять модалки в зависимости от выбранного тарифа
    const tariffButton = $('.tariffs_info-button__js');
    const tariffTransparentButton = $('.tariffs_info-button__transparent__js');

    // функция которая срабатывает при изменении активного элемента. добавляет анимацию изчезновления\появления
    // и также туда атрибутами прокидываются данные для отображения в блоке
    const changeActiveTariffs = (data) => {
        tariffInfoBlock.animate({ opacity: 0 }, 200);
        setTimeout(() => {
            // вешаем класс на контейнер
            tariffInfoBlock.attr('class', 'tariffs_info-anim__js tariffs_info-' + data.alias.toLowerCase());

            // название тарифа
            tariffTitle.text(data.alias);

            // стоимость тарифа
            tariffPriceFirst.html(data.price.replace(/руб\.?/, '<span class="rouble">o</span>'));

            // скрываем 2 блок
            if (data.request.length === 0) {
                secondPriceBox.css('display', 'none');
            } else {
                secondPriceBox.css('display', 'flex');
                tariffRequests.text(data.request);
                tariffHintRequests.text(data.request_hint);
            }

            // описание тарифа
            tariffText.text(data.description);

            tariffInfoBlock.animate({ opacity: 1 }, 200);
        }, 200);
    }

    if ($('.tariffs_type-item__js').length > 0) {

        for (let i = 0; i < $('.tariffs_type-item__js').length; i++) {
            document.querySelectorAll('.tariffs_type-item__js')[i].addEventListener('click', function () {

                // если этот элемент уже активен - ничего не делать
                if (!$(this).hasClass('active')) {
                    $('.tariffs_type-item__js.active').removeClass('active');
                    $(this).addClass('active');

                    changeActiveTariffs($(this).data('json'));
                }
            });
        }
    }

    // изменение фона в зависимости от ширины в мобильной версии
    const tariffRectangle = $('.tariffs_rectangle__js');

    if ($(window).width() <= '767' && $(window).width() > '320') {

        function setTariffRectanglePosition(e) {
            let actualWidth = $(window).width()

            let topPosition = -(actualWidth - 320) * 0.8;
            let actualHeight = 295 + (actualWidth - 320) * 0.95;
            let cssValues = {
                "top": topPosition,
                "height": actualHeight
            }
            tariffRectangle.css(cssValues);
        }

        setTariffRectanglePosition();
        window.addEventListener("resize", setTariffRectanglePosition, false);
    }
};